"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonColumn = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
exports.ButtonColumn = styled_1.default.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '>*:not(:last-of-type)': {
        marginBottom: theme.spacing.m,
    },
}));
//# sourceMappingURL=button_column.js.map